import { Steps } from "antd";
import "./steps-box.styles.scss";
import { useTranslation } from "react-i18next";

interface StepsBoxProps {
  title: string;
  current: number;
}

export default function StepsBox({ title, current }: StepsBoxProps) {
  const { Step } = Steps;
  const { t } = useTranslation(["gestao_de_aulas"]);

  return (
    <div className="steps-box__wrapper" style={{ width: "100%" }}>
      <h5>{title}</h5>
      <Steps direction="vertical" current={current}>
        <Step title={t("gestao_de_aulas:taughtContent")} />
        <Step title={t("gestao_de_aulas:frequenciesAndSkills")} />
      </Steps>
    </div>
  );
}